// Подтверждение действия — своим окном, а не системным. SMY-118
//
// `window.confirm` выглядит как окно браузера, а не как часть приложения:
// чужая типографика, чужие кнопки, «localhost:3000 сообщает» в заголовке. На
// вопросе «удалить переписку?» это худшее из возможных — человек читает не
// текст, а незнакомую рамку, и жмёт что попало.
//
// Ещё оно блокирует поток: пока окно открыто, страница не рисуется вовсе, а
// на телефоне выглядит системным предупреждением о чём-то опасном.

import type { ReactNode } from 'react'

import { Button } from './controls.tsx'
import { Sheet } from './surfaces.tsx'

export interface ConfirmProps {
  open: boolean
  /** Заголовок вопроса: что именно произойдёт. */
  title: string
  /** Пояснение: что будет с данными и можно ли это вернуть. */
  children?: ReactNode
  /** Подпись кнопки действия. Глагол, а не «ОК»: «ОК» не называет действия. */
  action: string
  /** Действие необратимо — кнопка красная. */
  danger?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function Confirm({ open, title, children, action, danger, onConfirm, onCancel }: ConfirmProps) {
  return (
    <Sheet open={open} onClose={onCancel} label={title} closable>
      <h2 className="confirm__title">{title}</h2>
      {children != null ? <p className="confirm__explain">{children}</p> : null}

      <div className="confirm__actions">
        <Button kind={danger === true ? 'danger' : 'primary'} onClick={onConfirm}>
          {action}
        </Button>
        {/* Отмена равной ширины с действием: спрятанный выход — не выход, а
            на необратимом действии он нужен не меньше самого действия. */}
        <Button kind="ghost" onClick={onCancel}>
          Отмена
        </Button>
      </div>
    </Sheet>
  )
}
